// Constants extracted from ChatContainerModule.js

// Constants
export const INTIAL_RECORDS_NUMBER = 15;
export const NAME = "conversation";
export const UPDATE_CHAT_INFO = "UPDATE_CHAT_INFO" + " " + NAME;
export const UPDATE_TEXT_BOX_FOCUS_STATE = "UPDATE_TEXT_BOX" + " " + NAME;
export const SET_DRAFT_MESSAGE_DATA = "SET_DRAFT_MESSAGE_DATA" + " " + NAME;
